import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatCardModule } from '@angular/material/card';

import { PackageComponent } from './package.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    
    MatCardModule
  ],
  exports: [
    PackageComponent
  ],
  providers: [
  ],
  declarations: [
    PackageComponent
  ]
})
export class PackageModule { }
